(() => {
  const key = 'kgDraftPreview';
  const current = new URL(location.href).searchParams.get('preview_theme_id');
  if (current) sessionStorage.setItem(key, current);
  const preview = current || sessionStorage.getItem(key);
  if (preview !== '188930031919') return;
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || /^(\/checkout|\/cart|\/account)/.test(url.pathname)) return;
    url.searchParams.set('preview_theme_id', preview);
    link.href = url.href;
  }, true);
})();
